import { Component } from '@grafikr/components';

import ShopSwitch from '../utils/components/shop-switch';
import { NonNullish } from '../utils/nullish-check';

export default Component((node) => {
  ShopSwitch(node, node.hasAttribute('data-geo-track'));

  const template = NonNullish(
    node.querySelector<HTMLTemplateElement>('template[data-switcher-content]'),
  );
  const buttons = document.querySelectorAll('[data-load="markets-select"]');

  buttons.forEach((button) => {
    button.innerHTML = NonNullish(template.innerHTML);
  });
});
